// Overlays that own the Escape key while open: the first Esc must close them, not whatever panel is
// listening on the document behind them. PrimeNG renders its popup menu, tiered menu, popover and
// context menu roots only while open, and hides them on Esc without stopping the event, so they are
// matched by class.
const OPEN_OVERLAY_SELECTOR = [
  // A closing backdrop keeps its base class until its fade ends, so only a showing one counts.
  '.cdk-overlay-backdrop-showing',
  '.p-overlay',
  '.p-select-overlay',
  '.p-datepicker-panel',
  '.p-menu-overlay',
  '.p-tieredmenu-overlay',
  '.p-popover',
  '.p-contextmenu',
  '.mat-mdc-autocomplete-panel',
  '[role="combobox"][aria-expanded="true"]',
].join(',')

/** Pane class for an overlay that stays docked and never closes on Esc, such as a side panel. */
export const NOT_DISMISSABLE_OVERLAY_CLASS = 'flx-not-dismissable-overlay'

// A detached overlay leaves its empty pane behind until it is disposed. Tooltips and toasts live in
// CDK panes too but are not something the user dismisses with Esc, so none of these panes count.
const isDismissablePane = (pane: Element): boolean =>
  pane.childElementCount > 0 &&
  !pane.classList.contains(NOT_DISMISSABLE_OVERLAY_CLASS) &&
  !pane.querySelector('.flx-tooltip, flx-toast-container')

/**
 * Whether a dismissable overlay (modal, dropdown, picker, popup menu, popover) is open anywhere in the
 * document. Read it in the capture phase of a keydown: a modal closed by the body-level CDK dispatcher
 * is already gone from the DOM by the time a bubble-phase document listener runs.
 */
export const hasOpenOverlay = (doc: Document): boolean =>
  !!doc.querySelector(OPEN_OVERLAY_SELECTOR) ||
  Array.from(doc.querySelectorAll('.cdk-overlay-pane')).some(isDismissablePane)
